import { useState, type ComponentProps } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

// `ComponentProps` inclui `ref`: o formulário foca o campo com erro por ele (React 19 repassa
// `ref` como prop comum).
type PasswordInputProps = Omit<ComponentProps<'input'>, 'type'>;

/**
 * Campo de senha com botão para revelar o que foi digitado. Senha longa (uma frase) é a
 * recomendação; sem poder conferir, a pessoa digita às cegas e erra.
 * Começa oculto: revelar é escolha de quem digita.
 */
export function PasswordInput({ className, ...props }: PasswordInputProps) {
  const [visivel, setVisivel] = useState(false);

  return (
    <div className="relative">
      {/* `pr-10` reserva o espaço do botão para o texto digitado não passar por baixo dele. */}
      <Input {...props} type={visivel ? 'text' : 'password'} className={cn('pr-10', className)} />

      {/* O botão de ícone é um pouco menor que o campo: o recuo de meio passo o centraliza dentro
          da borda, em vez de cobri-la. */}
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => setVisivel((atual) => !atual)}
        // O rótulo é a AÇÃO do clique, e `aria-pressed` diz o estado atual — o leitor de tela
        // anuncia "Mostrar senha, não pressionado" e muda ao alternar.
        aria-label={visivel ? 'Ocultar senha' : 'Mostrar senha'}
        aria-pressed={visivel}
        className="absolute right-0.5 top-0.5"
      >
        {visivel ? <EyeOff aria-hidden /> : <Eye aria-hidden />}
      </Button>
    </div>
  );
}
